export default element => [ ...element.parentNode.children ].indexOf( element )
